import { BizzCustomersService } from './../../_services/bizz-customers.service';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { GlobalService } from 'src/app/_services/global.service';
import { OverlayPanel } from 'primeng/overlaypanel';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { PaginatorComponent } from 'src/app/_forms/paginator/paginator.component';
import { AppBaseDataService } from 'src/app/_services/app-base-data.service';
import { Table } from 'primeng/table';
import { FilterServiceService } from 'src/app/_services/filter-service.service';
import { formatDate } from '@angular/common';
import { ConnMessageService } from 'src/app/_services/conn-message.service';
import { AccountInfo, DashboardCustomerListResponse, DashboardSaleSummary } from 'src/app/_models/internal-management-dashboard/dashboard/DashboardSaleSummary';
import { environment } from 'src/environments/environment';
import { PlanDataService } from 'src/app/_services/plan-data.service';

@Component({
  selector: 'app-bizz-customers-list',
  templateUrl: './bizz-customers-list.component.html',
  styleUrls: ['./bizz-customers-list.component.scss'],
})
export class BizzCustomersListComponent implements OnInit {
  _globals = GlobalService;
  isMobileView = false;
  @ViewChild('dt') dataTable: Table;
  @ViewChild('op') op: OverlayPanel;
  @ViewChild('paginator') paginator: PaginatorComponent;

  page = 0;
  rows = 25;
  rowsPerPageOptions: number[] = [10, 15, 20, 25, 50, 100];
  private autoRowsByScreen = false;
  totalRecords = 0;
  dataList: any = null;
  private sortState: { field: string; order: number } | null = null;
  baseDataList: any[] = [];
  filteredDataList: any[] = [];
  noData: boolean = false;
  get skeletonRows(): Array<{ id: string }> {
    const count = this.rows && this.rows > 0 ? this.rows : 10;
    return Array.from({ length: count }, (_, i) => ({ id: `sk-${i}` }));
  }
  //isSubscriptionCompleted:boolean=false;
  // summaryHeader: [['#','Full Name','Status']],
  // colflds: ['index','fullName', 'status'],
  colHeader = [
    [
      'Business Name',
      'City',
      'State',
      'Last Name',
      'First Name',
      'Phone',
      'Email',
      'Status',
      'Setup',
      'Plan',
      'Sub Amount',
      'Last Payment',
      'Payment Status',
      'Created Date',
    ],
  ];
  colflds = [
    'businessName',
    'cityLabel',
    'stateLabel',
    'contactLastName',
    'contactFirstName',
    'contactPhoneLabel',
    'contactEmailLabel',
    'statusLabel',
    'setupStatusLabel',
    'planLabel',
    'subAmountLabel',
    'lastPaymentLabel',
    'paymentStatusLabel',
    'createdDateLabel',
  ];
  // 14 columns on letter landscape (792pt): fixed widths sum to 752pt (20pt margins)
  // so short fields (city, state, phone, dates) never break mid-word.
  pdfTableOptions = {
    margin: { left: 20, right: 20 },
    tableWidth: 752,
    styles: { fontSize: 7, cellPadding: 3, overflow: 'linebreak', valign: 'middle' },
    headStyles: { fontSize: 7, halign: 'left' },
    columnStyles: {
      0: { cellWidth: 80 },
      1: { cellWidth: 52 },
      2: { cellWidth: 28 },
      3: { cellWidth: 48 },
      4: { cellWidth: 48 },
      5: { cellWidth: 66, overflow: 'visible' },
      6: { cellWidth: 124 },
      7: { cellWidth: 44 },
      8: { cellWidth: 38 },
      9: { cellWidth: 34 },
      10: { cellWidth: 46 },
      11: { cellWidth: 48 },
      12: { cellWidth: 44 },
      13: { cellWidth: 52 },
    },
  };
  searchText: any = '';
  lastSearchText = '';
  businessNameFilter = '';
  cityFilter = '';
  lastNameFilter = '';
  firstNameFilter = '';
  phoneFilter = '';
  emailFilter = '';
  subscriptionAmountFilter = '';

  orderParam = ''
  orderBy = ''
  loadingSummaryInfo: boolean = false;
  loadingCustomerList: boolean = false;
  selectedPlanFilter: string | null = null;
  selectedIntervalFilter: string | null = null;
  selectedStatusFilter: string | null = null;
  summaryCounts = { total: 0, active: 0, inactive: 0, onboarding: 0 };
  selectedStateFilter: string | null = null;
  stateFilterOptions: Array<{ label: string; value: string | null }> = [{ label: 'All', value: null }];
  private readonly fetchPageSize = 5000;
  planFilterOptions: Array<{ label: string; value: string | null }> = [
    { label: 'All', value: null },
    { label: 'Free', value: 'Free' },
    { label: 'Basic', value: 'Basic' },
    { label: 'Standard', value: 'Standard' },
    { label: 'Premium', value: 'Premium' }
  ];
  intervalFilterOptions: Array<{ label: string; value: string | null }> = [
    { label: 'All', value: null },
    { label: 'Monthly', value: 'Monthly' },
    { label: 'Yearly', value: 'Yearly' }
  ];
  statusFilterOptions: Array<{ label: string; value: string | null }> = [
    { label: 'All', value: null },
    { label: 'Active', value: 'Active' },
    { label: 'Inactive', value: 'Inactive' },
    { label: 'Deactivated', value: 'Deactivated' }
  ];
  createdDateModeOptions: Array<{ label: string; value: 'date' | 'month' | 'year' | 'range' }> = [
    { label: 'Month', value: 'month' },
    { label: 'Year', value: 'year' },
    { label: 'Range', value: 'range' }
  ];
  createdDateFilterMode: 'date' | 'month' | 'year' | 'range' = 'month';
  createdDateFilterDate: Date | null = null;
  createdDateFilterMonth: string | null = null;
  createdDateFilterYear: string | null = null;
  createdDateFilterRange: Date[] | null = null;
  lastLoginDateFilterRange: Date[] | null = null;
  createdMonthOptions: Array<{ label: string; value: string | null }> = [
    { label: 'All', value: null },
    { label: 'January', value: 'January' },
    { label: 'February', value: 'February' },
    { label: 'March', value: 'March' },
    { label: 'April', value: 'April' },
    { label: 'May', value: 'May' },
    { label: 'June', value: 'June' },
    { label: 'July', value: 'July' },
    { label: 'August', value: 'August' },
    { label: 'September', value: 'September' },
    { label: 'October', value: 'October' },
    { label: 'November', value: 'November' },
    { label: 'December', value: 'December' }
  ];
  createdYearOptions: Array<{ label: string; value: string | null }> = [{ label: 'All', value: null }];

  dashboardSummaryObj: DashboardSaleSummary = {
    currentSaleRevenue: 0,
    previousSaleRevenue: 0,
    currentSaleTaxCollected: 0,
    previousSaleTaxCollected: 0,
    currentFeeCollected: 0,
    previousFeeCollected: 0,
  };

  dashboaryCustomerList: Array<AccountInfo> = [];

  constructor(
    private _bizzCustomerService: BizzCustomersService,
    private _spinner: NgxSpinnerService,
    private _filterService: FilterServiceService,
    private _router: Router,
    private _abd: AppBaseDataService,
    private _connMessageService: ConnMessageService,
    private _planData: PlanDataService
  ) { }

  ngOnInit(): void {
    if (!this._abd.isAdmin) {
      this._router.navigateByUrl(this._abd.getDashboardRoute());
      return;
    }

    this._globals.componentName = `${this._globals.whiteLabel.wlName} Customers`;
    this._globals.showProductDelButton = false;
    this.updateResponsiveState();
    this.restorePagination();
    this.getDataList()

    this.getDashboardSummaryData();
  }

  // Keep the selected page size / page when the user opens a customer and comes back.
  // A normal page load always starts at the default (25 rows) unless we are returning from a customer.
  private readonly paginationStorageKey = 'bizz-customers-list-pagination';
  private readonly returningFromCustomerKey = 'bizz-customers-list-returning';

  private restorePagination(): void {
    try {
      const returning = sessionStorage.getItem(this.returningFromCustomerKey) === '1';
      sessionStorage.removeItem(this.returningFromCustomerKey);
      if (!returning) return;
      const saved = JSON.parse(sessionStorage.getItem(this.paginationStorageKey) || 'null');
      if (saved && this.rowsPerPageOptions.includes(saved.rows)) {
        this.rows = saved.rows;
        this.page = Number.isInteger(saved.page) && saved.page >= 0 ? saved.page : 0;
      }
    } catch { }
  }

  private savePagination(): void {
    try {
      sessionStorage.setItem(this.paginationStorageKey, JSON.stringify({ rows: this.rows, page: this.page }));
    } catch { }
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.updateResponsiveState();
    this.fitTableToViewport();
    if (!this.autoRowsByScreen) return;
    const prevRows = this.rows;
    this.setRowsByScreen();
    if (prevRows !== this.rows) {
      this.page = 0;
      this.getDataList();
    }
  }

  private updateResponsiveState(): void {
    this.isMobileView = window.innerWidth <= 768;
  }

  // Size the table body to the space left in the window so the table is the only vertical scroller.
  private fitTableToViewport(): void {
    const wrapper = this.dataTable?.el?.nativeElement?.querySelector('.p-datatable-wrapper') as HTMLElement | null;
    const card = wrapper?.closest('.conn-card') as HTMLElement | null;
    if (!wrapper || !card) return;
    // Paginator and card padding under the table stay fixed; keep a small gap at the page edge.
    const belowTable = card.getBoundingClientRect().bottom - wrapper.getBoundingClientRect().bottom;
    const available = window.innerHeight - wrapper.getBoundingClientRect().top - belowTable - 8;
    wrapper.style.maxHeight = `${Math.max(240, Math.floor(available))}px`;
  }

  customSort(e) {
    const last = this.orderParam

    switch (e.sortField) {
      case 'companyName':
        this.orderParam = 'companyName'
        break;
      case 'firstName':
        this.orderParam = 'firstName'
        break;
      case 'lastName':
        this.orderParam = 'lastName'
        break;
      case 'startedDate':
        this.orderParam = 'startedDate'
        break;
      default:
        this.orderParam = ''
    }

    if (this.orderParam !== '') {
      this.orderBy = this.orderBy == 'asc' ? 'desc' : 'asc'
      if (last !== this.orderParam) this.orderBy = 'asc'
      //this.getDataList()
    }
  }

  getDataList() {
    this.searchText = String(this._filterService.searchText || '').trim();
    this.loadingCustomerList = true;
    this._abd.showSpinner();
    this._bizzCustomerService
      .getAllCustomers(1, this.fetchPageSize, this.searchText || '')
      .subscribe({
        error: () => {
          this._abd.hideSpinner();
          this.loadingCustomerList = false;
        },
        next: (res) => {
        if (res?.success) {
          this._abd.hideSpinner();
          const preparedList = this.prepareCustomerList(res.data);

          this.baseDataList = preparedList;
          const countStatus = (s: string) => preparedList.filter((x: any) => x?.statusLabel === s).length;
          this.summaryCounts = {
            total: preparedList.length,
            active: countStatus('Active'),
            inactive: countStatus('Inactive'),
            onboarding: countStatus('Onboarding')
          };
          this.applyClientFilters(false);

          const uniquePlans: string[] = Array.from(
            new Set<string>(
              preparedList
                .map((x: any) => String(x?.planLabel || '').trim())
                .filter((x: string) => x.length > 0)
            )
          );
          this.planFilterOptions = [
            { label: 'All', value: null },
            ...uniquePlans.map((p) => ({ label: p, value: p }))
          ];
          const uniqueStatuses = Array.from(
            new Set<string>(
              preparedList
                .map((x: any) => String(x?.statusLabel || '').trim())
                .filter((x: string) => x.length > 0 && x !== 'Onboarding')
            )
          );
          const statusOrder: Record<string, number> = {
            Active: 1,
            Onboarding: 2,
            Inactive: 3,
            Deactivated: 4
          };
          uniqueStatuses.sort((a, b) => (statusOrder[a] ?? 999) - (statusOrder[b] ?? 999));
          this.statusFilterOptions = [
            { label: 'All', value: null },
            ...uniqueStatuses.map((s) => ({ label: s, value: s }))
          ];
          const uniqueStates: string[] = Array.from(
            new Set<string>(
              preparedList
                .map((x: any) => String(x?.stateLabel || '').trim())
                .filter((x: string) => x.length > 0)
            )
          ).sort((a, b) => a.localeCompare(b));
          this.stateFilterOptions = [
            { label: 'All', value: null },
            ...uniqueStates.map((s) => ({ label: s, value: s }))
          ];
          const uniqueYears: string[] = Array.from(
            new Set<string>(
              preparedList
                .map((x: any) => String(x?.startedYear || '').trim())
                .filter((x: string) => x.length > 0)
            )
          ).sort((a, b) => Number(b) - Number(a));
          this.createdYearOptions = [
            { label: 'All', value: null },
            ...uniqueYears.map((y) => ({ label: y, value: y }))
          ];
        }
        //  this.getDashboardCustomerListV2();
        this._abd.hideSpinner();
          this.loadingCustomerList = false;
          setTimeout(() => this.fitTableToViewport());
        },
      });
  }

  private prepareCustomerList(list: any[]): any[] {
    const rawList = Array.isArray(list) ? [...list] : [];

    // Environment value can be "production", "Production", "development", "Development"...; compare case-insensitively.
    const isProductionRow = (f: any) => String(f?.environment ?? '').trim().toLowerCase() === 'production';
    // Dev hosts (localhost, devadmin) always show non-production rows, including "development", even in a production build.
    const host = window.location.hostname.toLowerCase();
    const isDevHost = host === 'localhost' || host === '127.0.0.1' || host === 'devadmin.lincsell.com';

    let preparedList = rawList;
    if (environment.production && !isDevHost) {
      preparedList = preparedList.filter((f) => isProductionRow(f));
    } else {
      preparedList = preparedList.filter((f) => !isProductionRow(f));
    }

    preparedList = preparedList.filter((f) => {
      const isApnaStore =
        String(f?.businessName || '').trim().toLowerCase() ===
        'apna store';
      return isApnaStore || f?.currentSubscription != undefined;
    });

    preparedList.forEach((element) => {
            element.startedDate = element?.currentSubscription
              ? formatDate(
                element.currentSubscription.createdDate,
                'M/d/yyyy',
                'en-US'
              )
              : '';
            element.startedMonth = element?.currentSubscription?.createdDate
              ? formatDate(element.currentSubscription.createdDate, 'MMMM', 'en-US')
              : '';
            element.startedYear = element?.currentSubscription?.createdDate
              ? formatDate(element.currentSubscription.createdDate, 'yyyy', 'en-US')
              : '';
            element.startedTimestamp = element?.currentSubscription?.createdDate
              ? new Date(element.currentSubscription.createdDate).getTime()
              : null;
            // Login columns: fields come straight from GetBusinessCustomers (camelCase, PascalCase fallback).
            const lastLoginRaw = element?.lastLoginDate ?? element?.LastLoginDate;
            const lastLogin = lastLoginRaw ? new Date(lastLoginRaw) : null;
            const hasLastLogin = !!lastLogin && !isNaN(lastLogin.getTime());
            element.lastLoginTimestamp = hasLastLogin ? lastLogin.getTime() : null;
            element.lastLoginLabel = hasLastLogin ? formatDate(lastLogin, 'M/d/yyyy h:mm a', 'en-US') : '-';
            const rawLoginCount = element?.totalLoginCount ?? element?.TotalLoginCount;
            element.totalLoginCount = rawLoginCount != null && !isNaN(Number(rawLoginCount)) ? Number(rawLoginCount) : null;
            element.planLabel = element?.isFreeTrial
              ? 'Free'
              : element?.currentSubscription?.planName || '';
            // element.currentSubscription is a point-in-time report summary that goes stale the
            // moment a customer changes plans (confirmed: upgraded Free -> Plus, this summary still
            // showed Free/$0.00). element.subscription is the real, live SubscriptionModel (same
            // field name pattern as element.noOfLocations/.perNoOfRegister, already read elsewhere
            // in this admin codebase) — prefer it when present, same fix already verified on the
            // customer-detail Subscription tab.
            const richSubscription = element?.subscription ?? element?.Subscription;
            if (richSubscription) {
              const cosmosId = richSubscription?.planId ?? richSubscription?.PlanId;
              const matchedPlan = cosmosId != null
                ? this._planData.list.find((p: any) => String(p.cosmosId) === String(cosmosId))
                : null;
              if (matchedPlan?.planName) element.planLabel = matchedPlan.planName;

              const richTotal = this.parseNumericValue(richSubscription?.totalCost);
              if (richTotal !== null && richTotal > 0) {
                element.currentSubscription = { ...(element.currentSubscription || {}), total: richTotal };
              }
            }
            // lastPlanChangeToPlanTitle/lastPlanChangeFromPlanTitle/lastPlanChangeDate are top-level
            // fields on the GetBusinessCustomers row itself (confirmed live, independent of whether
            // `subscription` is populated) — "the plan last changed into," i.e. the customer's actual
            // current plan once GetBusinessCustomers's own currentSubscription snapshot has gone
            // stale. Applied unconditionally (not gated behind richSubscription) so a row without a
            // populated `subscription` field still gets the correction.
            const lastPlanChangeToTitle = element?.lastPlanChangeToPlanTitle || element?.LastPlanChangeToPlanTitle;
            if (lastPlanChangeToTitle) element.planLabel = lastPlanChangeToTitle;

            // Surface the switch itself (not just the resolved end state) so the list shows a
            // customer moved plans, not just what they're on now — same "Changed from X to Y on
            // <date>" copy the customer-detail Subscription tab already shows.
            const lastPlanChangeFromTitle = element?.lastPlanChangeFromPlanTitle || element?.LastPlanChangeFromPlanTitle;
            const lastPlanChangeDate = element?.lastPlanChangeDate || element?.LastPlanChangeDate;
            element.planChangedNote = (lastPlanChangeFromTitle && lastPlanChangeToTitle)
              ? `Changed from ${lastPlanChangeFromTitle} to ${lastPlanChangeToTitle}`
                + (lastPlanChangeDate ? ` on ${formatDate(lastPlanChangeDate, 'M/d/yyyy', 'en-US')}` : '')
              : null;

            // Next billing date — only on the live SubscriptionModel (richSubscription), not the
            // stale currentSubscription report summary. A placeholder "0001-01-01" (backend's "no
            // date set" sentinel, same as subscriptionExpire above) is treated as absent.
            const nextChargeDateRaw = richSubscription?.nextChargeDate ?? richSubscription?.NextChargeDate;
            element.nextChargeDateLabel = (nextChargeDateRaw && new Date(nextChargeDateRaw).getFullYear() > 1)
              ? formatDate(nextChargeDateRaw, 'M/d/yyyy', 'en-US')
              : null;
            element.intervalLabel = this.getPlanInterval(element?.invoice?.planInterval);
            element.statusLabel = this.resolveCustomerStatus(element);

            element.cityLabel = String(element?.city ?? element?.currentSubscription?.city ?? element?.businessSetup?.city ?? '').trim();
            element.stateLabel = String(element?.state ?? element?.currentSubscription?.state ?? element?.businessSetup?.state ?? '').trim();
            element.contactLastName = String(element?.lastName ?? element?.LastName ?? '').trim();
            element.contactFirstName = String(element?.firstName ?? element?.FirstName ?? '').trim();
            element.contactPhoneLabel = this.formatPhone(element?.businessPhone ?? element?.phone ?? element?.contactNumber ?? '');
            element.contactEmailLabel = String(element?.email ?? element?.businessEmail ?? element?.Email ?? '').trim();
            element.setupStatusLabel = this.resolveSetupStatus(element);

            // Last payment = last charge on the subscription summary (amount + date).
            const lastChargeRaw = element?.currentSubscription?.lastChargeDate;
            const hasLastCharge = !!lastChargeRaw && new Date(lastChargeRaw).getFullYear() > 1;
            const lastPaymentAmount = this.formatSubscriptionAmountPlain(element?.currentSubscription?.total);
            element.lastPaymentLabel = hasLastCharge && lastPaymentAmount !== '-'
              ? `$${lastPaymentAmount} - ${formatDate(lastChargeRaw, 'M/d/yy', 'en-US')}`
              : '';
            // Payment status: Current = charged and next charge not overdue; Default = next charge
            // date has passed; Pending = nothing charged yet (e.g. free trial / onboarding).
            const nextChargeTs = nextChargeDateRaw ? new Date(nextChargeDateRaw).getTime() : null;
            // Free plan has nothing to charge, so no payment status is shown.
            element.paymentStatusLabel = String(element.planLabel || '').trim().toLowerCase() === 'free'
              ? ''
              : !hasLastCharge
                ? 'Pending'
                : (nextChargeTs !== null && element.nextChargeDateLabel && nextChargeTs < Date.now() ? 'Default' : 'Current');
            // element.sales7D = this.getMetricValue(element, [
            //   'last7Days.sales',
            //   'last7days.sales',
            //   'sales7D',
            //   'sales7d',
            //   'sales7Days',
            //   'sales7days'
            // ]);
            // element.sales30D = this.getMetricValue(element, [
            //   'last30Days.sales',
            //   'last30days.sales',
            //   'sales30D',
            //   'sales30d',
            //   'sales30Days',
            //   'sales30days'
            // ]);
            // element.sales1Y = this.getMetricValue(element, [
            //   'last12Months.sales',
            //   'last12months.sales',
            //   'sales1Y',
            //   'sales1y',
            //   'sales12M',
            //   'sales12m',
            //   'sales12Months',
            //   'sales12months'
            // ]);
            // element.txn30D = this.getMetricValue(element, [
            //   'last30Days.transactions',
            //   'last30days.transactions',
            //   'txn30D',
            //   'txn30d',
            //   'transactions30D',
            //   'transactions30d',
            //   'transaction30D',
            //   'transaction30d'
            // ]);
    });

    // Default order: business name A-Z, with rows that have no real name last.
    return preparedList.sort((a: any, b: any) => {
      const aHasName = this.hasBusinessName(a);
      const bHasName = this.hasBusinessName(b);
      if (aHasName !== bHasName) return aHasName ? -1 : 1;
      return String(a?.businessName ?? '').localeCompare(String(b?.businessName ?? ''), undefined, { sensitivity: 'base' });
    });
  }

  private applyClientFilters(resetPage: boolean = true): void {
    if (resetPage) {
      this.page = 0;
    }

    const normalizedNameFilter = String(this.businessNameFilter || '').trim().toLowerCase();
    const normalizedAmountFilter = String(this.subscriptionAmountFilter || '').trim().toLowerCase();

    const filteredList = (this.baseDataList || []).filter((item: any) => {
      const businessName = String(item?.businessName || '').trim().toLowerCase();
      if (normalizedNameFilter && !businessName.includes(normalizedNameFilter)) {
        return false;
      }

      if (!this.containsText(item?.cityLabel, this.cityFilter)
        || !this.containsText(item?.contactLastName, this.lastNameFilter)
        || !this.containsText(item?.contactFirstName, this.firstNameFilter)
        || !this.containsText(item?.contactEmailLabel, this.emailFilter)
        || !this.matchesPhone(item?.contactPhoneLabel, this.phoneFilter)) {
        return false;
      }

      if (this.selectedStatusFilter && item?.statusLabel !== this.selectedStatusFilter) {
        return false;
      }

      if (this.selectedStateFilter && item?.stateLabel !== this.selectedStateFilter) {
        return false;
      }

      if (this.selectedPlanFilter && item?.planLabel !== this.selectedPlanFilter) {
        return false;
      }

      if (this.selectedIntervalFilter && item?.intervalLabel !== this.selectedIntervalFilter) {
        return false;
      }

      if (normalizedAmountFilter) {
        const amountText = this.formatSubscriptionAmountPlain(item?.currentSubscription?.total).toLowerCase();
        if (!amountText.includes(normalizedAmountFilter)) {
          return false;
        }
      }

      if (!this.matchesCreatedDateFilter(item)) {
        return false;
      }

      if (!this.matchesLastLoginDateFilter(item)) {
        return false;
      }

      return true;
    });

    this.filteredDataList = filteredList;
    this.applyCurrentSort();
    this.totalRecords = filteredList.length;
    this.noData = filteredList.length === 0;

    if (this.page > 0 && this.page * this.rows >= this.totalRecords) {
      this.page = 0;
    }

    this.applyCurrentPageSlice();
  }

  private containsText(value: any, query: string): boolean {
    const q = String(query || '').trim().toLowerCase();
    return !q || String(value || '').toLowerCase().includes(q);
  }

  // Digits-only comparison so "713822" matches "713-822-3765".
  private matchesPhone(value: any, query: string): boolean {
    const q = String(query || '').replace(/\D/g, '');
    if (!q) return this.containsText(value, query);
    return String(value || '').replace(/\D/g, '').includes(q);
  }

  // A name is real when it is not blank and not the '-' placeholder.
  private hasBusinessName(item: any): boolean {
    const name = String(item?.businessName ?? '').trim();
    return name !== '' && name !== '-';
  }

  // Header sort runs on the whole filtered list so it holds across pages.
  onCustomSort(e: { field: string; order: number }): void {
    this.sortState = e?.field ? { field: e.field, order: e.order ?? 1 } : null;
    this.applyCurrentSort();
    this.applyCurrentPageSlice();
  }

  private applyCurrentSort(): void {
    if (!this.sortState) return;
    const { field, order } = this.sortState;
    const isBusinessName = field === 'businessName';
    this.filteredDataList = [...this.filteredDataList].sort((a: any, b: any) => {
      // Placeholder business names stay last in either direction.
      if (isBusinessName) {
        const aHasName = this.hasBusinessName(a);
        const bHasName = this.hasBusinessName(b);
        if (aHasName !== bHasName) return aHasName ? -1 : 1;
      }
      const av = this.readPathValue(a, field);
      const bv = this.readPathValue(b, field);
      const cmp = typeof av === 'number' && typeof bv === 'number'
        ? av - bv
        : String(av ?? '').localeCompare(String(bv ?? ''), undefined, { numeric: true, sensitivity: 'base' });
      return cmp * order;
    });
  }

  private applyCurrentPageSlice(): void {
    this.savePagination();
    const startIndex = this.page * this.rows;
    const endIndex = startIndex + this.rows;
    this.dataList = (this.filteredDataList || []).slice(startIndex, endIndex);
  }

  private matchesCreatedDateFilter(item: any): boolean {
    if (this.createdDateFilterMode === 'date') {
      if (!this.createdDateFilterDate) return true;
      return item?.startedDate === formatDate(this.createdDateFilterDate, 'M/d/yyyy', 'en-US');
    }

    if (this.createdDateFilterMode === 'month') {
      if (!this.createdDateFilterMonth) return true;
      return item?.startedMonth === this.createdDateFilterMonth;
    }

    if (this.createdDateFilterMode === 'year') {
      if (!this.createdDateFilterYear) return true;
      return item?.startedYear === this.createdDateFilterYear;
    }

    const start = this.createdDateFilterRange?.[0]
      ? new Date(this.createdDateFilterRange[0]).setHours(0, 0, 0, 0)
      : null;
    const end = this.createdDateFilterRange?.[1]
      ? new Date(this.createdDateFilterRange[1]).setHours(23, 59, 59, 999)
      : null;

    if (start == null || end == null) {
      return true;
    }

    const timestamp = item?.startedTimestamp;
    return timestamp != null && timestamp >= start && timestamp <= end;
  }

  private matchesLastLoginDateFilter(item: any): boolean {
    const start = this.lastLoginDateFilterRange?.[0]
      ? new Date(this.lastLoginDateFilterRange[0]).setHours(0, 0, 0, 0)
      : null;
    const end = this.lastLoginDateFilterRange?.[1]
      ? new Date(this.lastLoginDateFilterRange[1]).setHours(23, 59, 59, 999)
      : null;

    if (start == null || end == null) {
      return true;
    }

    const timestamp = item?.lastLoginTimestamp;
    return timestamp != null && timestamp >= start && timestamp <= end;
  }

  applyLastLoginDateFilter() {
    this.applyClientFilters();
  }

  getDashboardCustomerListV2() {
    this._abd.showSpinner();
    this.dataList = [];
    const parameters = {
      "ReportName": "adminaccountlist",
      "ReportParameters": [
        { "Key": "DurationType", "Value": "Last30Days" },
        { "Key": "AccountId", "Value": "12345" }
      ]
    }

    this._bizzCustomerService
      .getDashboardCustomerListV2(parameters)
      .subscribe((res) => {
        if (res?.success) {
          // this.dashboaryCustomerList = res.data;
          //    this.dataList = this.dashboaryCustomerList
          // this.totalRecords = res.totalRecords
        }
        this._abd.hideSpinner();
      });
  }


  getDashboardSummaryData() {
    // Admin (role 1001) login: the summary is hidden (its HTML block is commented out), so the
    // adminaccountsummary GetReport call is skipped.
    const roles: any[] = this._globals.userInfo?.role ?? [];
    if (Array.isArray(roles) && roles.some((r) => String(r) === '1001')) return;

    this.loadingSummaryInfo = true;
    const parameters = {
      "ReportName": "adminaccountsummary",
      "ReportParameters": [
        { "Key": "DurationType", "Value": "Last30Days" },
        { "Key": "AccountId", "Value": "12345" }
      ]
    }

    this._bizzCustomerService
      .getDashboardSummary(parameters)
      .subscribe((res) => {
        if (res?.success) {
          this.dashboardSummaryObj = res.data;
        }
         this.loadingSummaryInfo = false;
      });
  }



  getDate(status, date) {
    if (status.accountStatusString == 'Deactivated Account') {
      return '-';
    } else {
      return date;
    }
  }

  clearSearchText() {
    this.searchText = '';
    if (this.lastSearchText.length > 0) {
      this.lastSearchText = '';
      this.filterButtonPressed();
    }
  }
  searchFilterText() {
    this.page = 0;
    this.noData = false;
    this.lastSearchText = this.searchText || '';
    this.getDataList();
  }
  clearFilterSearch() {
    this.searchText = '';
    this.page = 0;
    this.noData = false;
    this.lastSearchText = '';
    this.getDataList();
  }

  searchTextSearch() {
    if (this.searchText.length < 1 && this.lastSearchText.length < 1)
      return;
    if (this.searchText === this.lastSearchText) return;
    this.lastSearchText = this.searchText;
    this.filterButtonPressed();
  }

  implementLocalFilter() {
    this.applyClientFilters();
  }
  getPlanInterval(interval) {
    if (interval === 1) {
      return 'Monthly';
    } else {
      return 'Yearly';
    }
  }

  applyDropdownFilter(value: string | null, field: string) {
    this.applyClientFilters();
  }

  onCreatedDateModeChange() {
    this.createdDateFilterDate = null;
    this.createdDateFilterMonth = null;
    this.createdDateFilterYear = null;
    this.createdDateFilterRange = null;
    this.applyClientFilters();
  }

  hasCreatedDateFilterValue(): boolean {
    if (this.createdDateFilterMode === 'date') return !!this.createdDateFilterDate;
    if (this.createdDateFilterMode === 'month') return !!this.createdDateFilterMonth;
    if (this.createdDateFilterMode === 'year') return !!this.createdDateFilterYear;
    return !!(this.createdDateFilterRange?.[0] || this.createdDateFilterRange?.[1]);
  }

  clearCreatedDateSelection() {
    this.createdDateFilterDate = null;
    this.createdDateFilterMonth = null;
    this.createdDateFilterYear = null;
    this.createdDateFilterRange = null;
    this.applyClientFilters();
  }

  applyCreatedDateFilter() {
    this.applyClientFilters();
  }

  private clearCreatedDateFilters() {
    this.createdDateFilterDate = null;
    this.createdDateFilterMonth = null;
    this.createdDateFilterYear = null;
    this.createdDateFilterRange = null;
  }

  formatSubscriptionAmountPlain(value: any): string {
    const raw = String(value ?? '').trim();
    if (!raw) return '-';

    // Handle values like "symbol0.00" or "$12.30" by extracting numeric part.
    const match = raw.match(/-?\d+(?:\.\d+)?/);
    const parsed = match ? Number(match[0]) : Number(raw.replace(/,/g, ''));
    if (!Number.isFinite(parsed)) return '-';

    return parsed.toFixed(2);
  }

  formatMetricAmountPlain(value: any): string {
    const parsed = this.parseNumericValue(value);
    if (parsed === null) return '0.00';
    return parsed.toFixed(2);
  }

  formatMetricCount(value: any): string {
    const parsed = this.parseNumericValue(value);
    if (parsed === null) return '0';
    return Math.round(parsed).toString();
  }

  private getMetricValue(item: any, paths: string[]): number {
    for (const path of paths) {
      const raw = this.readPathValue(item, path);
      const parsed = this.parseNumericValue(raw);
      if (parsed !== null) return parsed;
    }
    return 0;
  }

  private readPathValue(source: any, path: string): any {
    if (!source || !path) return null;
    return path.split('.').reduce((acc: any, key: string) => {
      if (acc === null || acc === undefined) return null;
      return acc[key];
    }, source);
  }

  private parseNumericValue(raw: any): number | null {
    if (raw === null || raw === undefined || raw === '') return null;
    if (typeof raw === 'number') {
      return Number.isFinite(raw) ? raw : null;
    }
    const text = String(raw).trim();
    if (!text) return null;
    const match = text.match(/-?\d+(?:\.\d+)?/);
    if (!match) return null;
    const parsed = Number(match[0]);
    return Number.isFinite(parsed) ? parsed : null;
  }
  callbackFuncFromFilter(event) {
    this.filterButtonPressed();
  }

  filterButtonPressed() {
    this.searchText = String(this._filterService.searchText || '').trim();
    this.page = 0;
    this.getDataList();
  }

  getPrice(item: any) {
    try {
      if (item.isFreeTrial) return 0.0;
      if (item.invoice == null) return 0.0;
      if (item.subscriptionInvoice == null) return 0.0;
      if (item.subscriptionInvoice.plans[0])
        return item.subscriptionInvoice.plans[0].price;
      return 0.0;
    } catch {
      return 0.0;
    }
  }
  getAccountStatus(item: any) {
    try {
      if (item.accountStatusString == 'Deactivated Account')
        return 'Deactivated';
      return 'Active';
    } catch {
      return 0.0;
    }
  }

  private resolveCustomerStatus(item: any): string {
    const statusStringRaw = String(item?.accountStatusString || '').trim().toLowerCase();
    const statusCode = Number(item?.accountStatus);

    if (
      statusStringRaw.includes('deactivated')
      || statusStringRaw.includes('deactive')
    ) {
      return 'Deactivated';
    }

    if (
      statusStringRaw.includes('expired')
      || statusCode === 4
    ) {
      return 'Inactive';
    }

    const apiStatusRaw = String(
      item?.accountStatusDisplay ??
      item?.AccountStatusDisplay ??
      ''
    ).trim().toLowerCase();

    if (apiStatusRaw === 'active') return 'Active';
    if (apiStatusRaw === 'onboarding') return 'Active';
    if (apiStatusRaw === 'inactive') return 'Inactive';
    if (apiStatusRaw === 'deactivated') return 'Deactivated';

    // Backward-compatible fallback for older payloads.
    if (statusStringRaw === 'deactivated account') return 'Deactivated';
    return 'Active';
  }

  private formatPhone(raw: any): string {
    const digits = String(raw ?? '').replace(/\D/g, '');
    const local = digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
    if (local.length === 10) {
      return `${local.slice(0, 3)}-${local.slice(3, 6)}-${local.slice(6)}`;
    }
    return String(raw ?? '').trim();
  }

  // Setup steps (businessInfo, storeTemplate, products, shipping, payment):
  // all complete = Green, all notStarted = Red, anything in between = Yellow.
  // salesChannels is ignored here: it is complete for all customers and would hide real progress.
  private resolveSetupStatus(item: any): string {
    const steps = item?.setupStatus ?? item?.SetupStatus;
    if (!steps || typeof steps !== 'object') return '';
    const values = Object.keys(steps)
      .filter((key) => key !== 'salesChannels')
      .map((key) => String(steps[key]).toLowerCase());
    if (!values.length) return '';
    if (values.every((v) => v === 'complete')) return 'Green';
    if (values.every((v) => v === 'notstarted')) return 'Red';
    return 'Yellow';
  }

  // Hover text for the Setup dot: one line per step, e.g. "Sales Channels: Complete".
  getSetupTooltip(item: any): string {
    const steps = item?.setupStatus ?? item?.SetupStatus;
    if (!steps || typeof steps !== 'object') return '';
    const labels: Record<string, string> = {
      salesChannels: 'Sales Channels',
      businessInfo: 'Business Info',
      storeTemplate: 'Store Template',
      products: 'Products',
      shipping: 'Shipping',
      payment: 'Payment',
    };
    return Object.keys(steps)
      .map((key) => {
        const value = String(steps[key]).toLowerCase();
        const text = value === 'complete' ? 'Complete' : value === 'notstarted' ? 'Not started' : String(steps[key]);
        return `${labels[key] ?? key}: ${text}`;
      })
      .join(' | ');
  }

  getSetupStatusColor(status: string): string {
    if (status === 'Green') return '#059669';
    if (status === 'Yellow') return '#d97706';
    return '#dc2626';
  }

  getPaymentStatusColor(status: string): string {
    if (status === 'Default') return '#dc2626';
    if (status === 'Pending') return '#d97706';
    return '#059669';
  }

  getStatusColor(status: string): string {
    const normalized = String(status || '').trim().toLowerCase();
    if (normalized === 'inactive' || normalized === 'deactivated') return '#dc2626';
    if (normalized === 'onboarding') return '#d97706';
    return '#059669';
  }
  onPageChange(e) {
    if (e?.rows && e.rows !== this.rows) {
      this.autoRowsByScreen = false;
    }
    this.rows = e.rows;
    this.page = e.page;
    this.applyCurrentPageSlice();
  }

  private setRowsByScreen(): void {
    const h = window?.innerHeight || 900;
    if (h <= 760) {
      this.rows = 10;
      return;
    }
    if (h <= 920) {
      this.rows = 15;
      return;
    }
    this.rows = 20;
  }
  clear(table: Table) {
    table.clear();
  }
  onRowClick(e: any) {
    const rowData = e?.data ?? e;
    const businessId =
      rowData?.currentSubscription?.businessId ?? rowData?.businessId;
    const userId = rowData?.currentSubscription?.userId ?? rowData?.userId;

    if (businessId && userId) {
      try { sessionStorage.setItem(this.returningFromCustomerKey, '1'); } catch { }
      this._router.navigate(['bizz/customers-detail', businessId, userId]);
      return;
    }

    this._connMessageService.showToastMessage(
      `Customer detail is not available yet for ${rowData?.businessName || 'this customer'}.`,
      'error'
    );

    // const parameters = {
    //       ReportName: 'adminaccountdetail',
    //       ReportParameters: [
    //           { Key: 'BusinessId', Value: rowData.currentSubscription.businessId },
    //           { Key: 'UserId', Value: rowData.currentSubscription.userId },
    //       ],
    //   };

   
    // if (rowData.currentSubscription != undefined) {
    //   this._bizzCustomerService.activeItem = JSON.parse(
    //     JSON.stringify(rowData)
    //   );
    //   this._router.navigate(['bizz/customers-detail']);
    // } else {
    //   this._connMessageService.showToastMessage(
    //     `There is no subscription available yet for ${rowData.businessName} `,
    //     'error'
    //   );
    //   this._spinner.hide();
    // }
  }

  private getExportSource(): any[] {
    if (this.filteredDataList?.length > 0) {
      return this.filteredDataList;
    }

    if (this.baseDataList?.length > 0) {
      return this.baseDataList;
    }

    return this.dataList || [];
  }

  private buildCustomerExportRows(source: any[]): any[] {
    return (source || []).map((item) => ({
      businessName: item?.businessName || '',
      statusLabel: this.resolveCustomerStatus(item),
      planLabel: item?.planLabel || '',
      subAmountLabel: this.getExportSubAmountLabel(item),
      createdDateLabel: item?.startedDate || '',
      cityLabel: item?.cityLabel || '',
      stateLabel: item?.stateLabel || '',
      contactLastName: item?.contactLastName || '',
      contactFirstName: item?.contactFirstName || '',
      contactPhoneLabel: item?.contactPhoneLabel || '',
      contactEmailLabel: item?.contactEmailLabel || '',
      setupStatusLabel: item?.setupStatusLabel || '',
      lastPaymentLabel: item?.lastPaymentLabel || '',
      paymentStatusLabel: item?.paymentStatusLabel || '',
    }));
  }

  private getExportSubAmountLabel(item: any): string {
    const amount = this.formatSubscriptionAmountPlain(item?.currentSubscription?.total);
    if (amount === '-') {
      return '-';
    }

    return `$${amount}`;
  }

  exportExcel() {
    const list = this.buildCustomerExportRows(this.getExportSource());

    this._abd.exportExcel(
      list,
      this.colHeader[0],
      this.colflds,
      `${this._globals.whiteLabel.wlName} Customers`,
      false
    );
  }

  exportPdf() {
    try {
      const list = this.buildCustomerExportRows(this.getExportSource());

      this._abd.exportPdf(
        list,
        this.colHeader,
        this.colflds,
        `${this._globals.whiteLabel.wlName} Customers`,
        false,
        false,
        false,
        false,
        null,
        this.pdfTableOptions
      );
    } catch (error) {
      console.log(error);
    }
  }

  onRowUnselect(e) { }

  onPage(e) { }
}
